import React, { FC } from 'react'
import { Typography, Button, Image } from 'antd'
import { ArrowRightOutlined } from '@ant-design/icons'
import { Container, descriptionStyle, titleStyle } from './CardSuccess.styles'
import { buttonStyle } from '../ChangePasswordInputs/ChangePasswordInputs.styles'
import { useTranslation } from 'react-i18next'

interface CardSuccessProps {
  onContinue: () => void
}

const CardSuccess: FC<CardSuccessProps> = ({ onContinue }) => {
  const { t } = useTranslation()
  return (
    <Container>
      <Image
        preview={false}
        src='https://odin-images-and-files-production.s3.us-east-1.amazonaws.com/shield_success.svg'
      />
      <Typography.Title level={4} style={titleStyle}>
        {t('success_change_password')}
      </Typography.Title>
      <Typography.Text style={descriptionStyle}>{t('thank_helping_platform_safe')}</Typography.Text>
      <Button block icon={<ArrowRightOutlined />} style={buttonStyle} onClick={onContinue}>
        {t('continue')}
      </Button>
    </Container>
  )
}

export default CardSuccess
